import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobileMenuOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <NavLink
            to="/"
            className="flex items-center gap-2 shrink-0"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-camera-lens-line text-background-50 text-base"></i>
            </span>
            <span className="text-lg font-semibold font-heading text-foreground-950 whitespace-nowrap">
              草莓色研社
            </span>
          </NavLink>

          <div className="hidden md:flex items-center gap-1">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                }`
              }
            >
              首页
            </NavLink>

            <div className="relative">
              <button
                onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${isCategoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isCategoryOpen && (
                <div className="absolute top-full left-0 mt-1 w-56 bg-background-50 rounded-lg border border-background-200/70 shadow-lg py-2 z-50">
                  {categories.map((cat) => (
                    <NavLink
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      onClick={() => setIsCategoryOpen(false)}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors duration-150"
                    >
                      <span className="w-5 h-5 inline-flex items-center justify-center mr-2">
                        <i className={`${cat.icon} text-xs`}></i>
                      </span>
                      {cat.name}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>

            <NavLink
              to="/about"
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                }`
              }
            >
              关于我们
            </NavLink>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200/70 transition-colors cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 overflow-y-auto">
          <div className="px-4 py-6 flex flex-col gap-2">
            <NavLink
              to="/"
              end
              className="px-4 py-3 rounded-lg text-base font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              首页
            </NavLink>
            <div className="px-4 py-2 text-sm font-semibold text-foreground-400 uppercase tracking-wide">
              分类浏览
            </div>
            {categories.map((cat) => (
              <NavLink
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 rounded-lg text-base text-foreground-700 hover:bg-background-100 transition-colors flex items-center gap-3"
              >
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={cat.icon}></i>
                </span>
                {cat.name}
              </NavLink>
            ))}
            <div className="border-t border-background-200/70 my-2"></div>
            <NavLink
              to="/about"
              className="px-4 py-3 rounded-lg text-base font-medium text-foreground-700 hover:bg-background-100 transition-colors"
            >
              关于我们
            </NavLink>
          </div>
        </div>
      )}

      {isCategoryOpen && (
        <div
          className="hidden md:block fixed inset-0 z-30"
          onClick={() => setIsCategoryOpen(false)}
        ></div>
      )}
    </nav>
  );
}